import React, { useState, useEffect } from 'react';
import Form from '../../../../../../component/Form';
import Service from '../../../../../../../apiService';
import withReference from 'view/hoc/withReference';
import {
  fetchSexs,
  getDistrics,
  getReligions,
  getJobs,
} from '../../../../../DataProvider';
import moment from 'moment';
import '../../../../../form.css';
import { Modal } from 'react-bootstrap';
import Alert from 'view/component/Alert';
import Table from 'view/component/Table';
import { withFormik } from 'formik';
import InfoModal from '../../../modules/InfoModal';
import useDataFetching from 'view/hooks/useDataFetching';
import apiService from '../../../../../../../apiService';

const PenilaianResult = ({ id }) => {
  const [ results, setResults ] = useState('');

  const getPenilaian = async (idArgument) => {
    try {
      const response = await apiService.get(
        `/department/penilaian/result/${ idArgument }`
      );
      if (response) setResults(response);
    } catch (error) {
      setResults('');
    }
  };

  useEffect(() => {
    getPenilaian(id);
  }, [ id ]);

  return results.data ? (
    <span>{`score : ${ results.data.total_score } | keterangan : ${ results.data.tingkat_mutu }`}</span>
  ) : results.message ? (
    <span>{results.message}</span>
  ) : (
    ''
  );
};

const Form1 = ({
  data,
  values,
  handleChange,
  setFieldValue,
  handleSubmit,
  status,
  setData,
  setIsProgressHidden,
  nextStep,
  setStep,
  isShow,
  typeId,
  dataPersyaratan,
}) => {
  const [ districts, setDistricts ] = useState('');
  const [ depDistricts, setDepDistricts ] = useState('');
  const [ villageData, setVillageData ] = useState([]);
  const [ depVillageData, setDepVillageData ] = useState([]);
  const [ isModalShow, setIsModalShow ] = useState(false);
  const [ registerId, setRegisterId ] = useState('');
  const [ detailPendaftaran, setDetailPendaftaran ] = useState('');
  const [ isModalInfoShow, setIsModalInfoShow ] = useState(false);
  const [ isFormShow, setIsFormShow ] = useState(false);

  const getVillages = async (param, flag) => {
    try {
      const responses = await Service.get(`/demograph/districts/find/${ param }`);
      if (responses) {
        const response = responses.data.villages.map((response) => {
          return { value: response.id, label: response.name };
        });
        if (flag === 'patient') {
          setVillageData(response);
        } else if (flag === 'department') {
          setDepVillageData(response);
        }
      }
    } catch (error) {
      return [];
    }
  };

  useEffect(() => {
    if (status) {
      if (status.code === 200) {
        setData((prevState) => ({
          ...prevState,
          idPendaftaran: status.data,
          formData: status.formData,
        }));
        nextStep();
      }
    }
  }, [ status ]);

  const getData = async (registerIdParam) => {
    try {
      const responses = await Service.get(
        `/department/find/${ registerIdParam }`
      );
      if (responses.status !== 'error') {
        setDetailPendaftaran(responses.data);
      } else {
        throw 'error'
      }
    } catch (error) {
      Alert('error', 'Tidak ditemukan');
    }
  };

  const getDetail = (value) => {
    setData((prevState) => ({
      ...prevState,
      existingData: value.trx_result,
      idPendaftaran: value.id,
      existingPersyaratan: value.persyaratan_result,
    }));
    setStep(5);
  };

  const getPerbaikan = (value) => {
    setData((prevState) => ({
      ...prevState,
      idPendaftaran: value.id
    }));
    setStep(6);
  };

  useEffect(() => {
    if (districts) getVillages(districts, 'patient');
  }, [ districts ]);

  useEffect(() => {
    if (depDistricts) getVillages(depDistricts, 'department');
  }, [ depDistricts ]);

  const setVerification = (value) =>
    value ? (
      <span
        className='text-success'
        style={ { width: '100%', textAlign: 'center', display: 'block' } }>
        <i className='fas fa-check-circle fa-2x' />
      </span>
    ) : (
      <span
        className='text-danger'
        style={ { width: '100%', textAlign: 'center', display: 'block' } }>
        <i className='fas fa-times-circle fa-2x' />
      </span>
    );

  return (
    isShow && (
      <div>
        <Modal
          show={ isModalShow }
          onHide={ () => {
            setIsModalShow(false);
            setDetailPendaftaran('');
          } }
          size='lg'
          centered>
          <Modal.Body>
            <div className='form-group row'>
              <div className='col-lg-4 col-8'>
                <input
                  type='text'
                  className='form-control'
                  placeholder='Kode Pendaftaran'
                  onChange={ (e) => {
                    e.persist();
                    setRegisterId(e.target.value);
                  } }
                />
              </div>
              <div className='col-lg-2 col-4'>
                <button
                  className='btn btn-success'
                  onClick={ () => getData(registerId) }>
                  Telusuri
                </button>
              </div>
            </div>
            <div className='row'>
              <div className={ 'col' }>
                {detailPendaftaran && (
                  <Table
                    headers={ [
                      'No',
                      'ID Pendaftaran',
                      'Nama',
                      'Alamat',
                      'Verifikasi',
                      detailPendaftaran?.visit_date ? 'Rencana Kunjungan' : '',
                      detailPendaftaran?.visit_date ? 'Hasil Penilaian' : '',
                      !detailPendaftaran?.visit_date ? 'Perbaikan Penilaian' : '',
                  ] }
                    data={ [ detailPendaftaran ] }
                    columnMapper={ (value) => [
                      value.id,
                      `${ value.patient && value.patient.name } ${
                        value.patient && value.patient.last_name
                      }`,
                      value.address,
                      setVerification(value.visit_date),
                      value.visit_date ? (
                        moment(value.visit_date).format('DD-MM-YYYY')
                      ) : (
                        <span
                          onClick={ () => {
                            setIsProgressHidden(true);
                            getDetail(detailPendaftaran);
                            setIsModalShow(false);

                            setDetailPendaftaran('');
                          } }
                          style={ { cursor: 'pointer' } }
                          className='text-primary'>
                          Edit
                        </span>
                      ),
                      value.id && value.visit_date && (
                        <PenilaianResult id={ value.id } />
                      ),
                      !value.visit_date ? (
                        moment(value.visit_date).format('DD-MM-YYYY')
                      ) : (
                        <span
                          onClick={ () => {
                            setIsProgressHidden(true);
                            getPerbaikan(detailPendaftaran);
                            setIsModalShow(false);

                            setDetailPendaftaran('');
                          } }
                          style={ { cursor: 'pointer' } }
                          className='text-primary'>
                          Perbaikan
                        </span>
                      ),
                    ] }
                    pagination={ false }
                    isBordered={ true }
                  />
                )}
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <h1>
          Form Permohonan Sertifikat Hygiene Sanitasi Rumah Makan / Restoran
        </h1>
        <p>
          sudah pernah mengajukan permohonan sertifikat?
          <span
            className='text-primary pointer'
            onClick={ () => setIsModalShow(true) }>
            &nbsp;klik disini
          </span>
        </p>
        <InfoModal
          data={ dataPersyaratan || [] }
          setIsModalShow={ setIsModalInfoShow }
          isModalShow={ isModalInfoShow }
          setIsFormShow={ setIsFormShow }
          isFormShow={ isFormShow }
          setIsProgressHidden={ setIsProgressHidden }
        />
        <p>
          <span className='text-danger'>*</span>pastikan melengkapi file
          persyaratan berikut sebelum mengisi form ->
          <span
            className='text-primary pointer'
            onClick={ () => setIsModalInfoShow(true) }>
            &nbsp;lihat persyaratan
          </span>
        </p>
        <div className={ `${ isFormShow ? '' : 'd-none' }` }>
          <Form>
            <Form.Row>
              <Form.Column lg={ 6 } md={ 12 }>
                <Form.TextInput
                  label='Nama'
                  name='name'
                  value={ values.name }
                  onChange={ handleChange }
                />
                <Form.TextInput
                  label='NIK'
                  name='nik'
                  value={ values.nik }
                  onChange={ handleChange }
                />
                <Form.Select
                  label='Jenis Kelamin'
                  name='sex'
                  value={ values.sex }
                  onChange={ handleChange }
                  options={ data.sexs }
                />
                <Form.TextInput
                  label='Tempat Lahir'
                  name='birth_place'
                  value={ values.birth_place }
                  onChange={ handleChange }
                />
                {/* <Form.TextInput label='Tanggal Lahir' /> */}
                <Form.DatePicker2
                  size='sm'
                  // placeholder="Sampai"
                  label='Tanggal Lahir'
                  name='birth_date'
                  value={ values.birth_date }
                  onChange={ setFieldValue }
                />
                <Form.Select
                  label='Kecamatan'
                  name='districts'
                  value={ districts }
                  onChange={ ({ target }) => setDistricts(target.value) }
                  options={ data.districts }
                />
                <Form.Select
                  label='Kelurahan/Desa'
                  name='village_id'
                  value={ values.village_id }
                  onChange={ handleChange }
                  options={ villageData }
                />
                <Form.TextAreaInput
                  label='Alamat'
                  name='address'
                  value={ values.address }
                  onChange={ handleChange }
                />
                <Form.TextInput
                  label='Kontak'
                  name='contact'
                  value={ values.contact }
                  onChange={ handleChange }
                />
                <Form.Select
                  label='Agama'
                  name='religion_id'
                  value={ values.religion_id }
                  onChange={ handleChange }
                  options={ data.religions }
                />
                {/* <Form.TextInput label='Status Perkawinan' /> */}
                <Form.Radio
                  label='Status Perkawinan'
                  name='marital_status_id'
                  value={ values.marital_status_id }
                  onChange={ handleChange }
                  options={ [
                    { value: 1, label: 'Menikah' },
                    { value: 2, label: 'Belum Menikah' },
                  ] }
                />
                <Form.Select
                  label='Pekerjaan'
                  name='job_id'
                  value={ values.job_id }
                  onChange={ handleChange }
                  options={ data.jobs }
                />
              </Form.Column>
              <Form.Column lg={ 6 } md={ 12 }>
                <Form.TextInput
                  label='Nama Perusahaan'
                  name='dep_name'
                  value={ values.dep_name }
                  onChange={ handleChange }
                />
                <Form.Select
                  label='Kecamatan'
                  name='districts'
                  value={ depDistricts }
                  onChange={ ({ target }) => setDepDistricts(target.value) }
                  options={ data.districts }
                />
                <Form.Select
                  label='Kelurahan/Desa'
                  name='dep_village_id'
                  value={ values.dep_village_id }
                  onChange={ handleChange }
                  options={ depVillageData }
                />
                <Form.TextAreaInput
                  label='Alamat Perusahaan'
                  name='dep_address'
                  value={ values.dep_address }
                  onChange={ handleChange }
                />
                <Form.Select
                  label='Golongan'
                  name='golongan'
                  value={ values.golongan }
                  onChange={ handleChange }
                  options={ [
                    { value: 'A1', label: 'A1' },
                    { value: 'A2', label: 'A2' },
                    { value: 'A3', label: 'A3' },
                    { value: 'B', label: 'B' },
                    { value: 'C', label: 'C' },
                  ] }
                />
                <Form.TextInput
                  label='Penanggung Jawab'
                  name='penanggung_jawab'
                  value={ values.penanggung_jawab }
                  onChange={ handleChange }
                />
                <Form.TextInput
                  label='Jumlah Karyawan'
                  name='jumlah_karyawan'
                  value={ values.jumlah_karyawan }
                  onChange={ handleChange }
                />
                <Form.TextInput
                  label='Jumlah Penjamah Makanan'
                  name='jumlah_penjamah_makanan'
                  value={ values.jumlah_penjamah_makanan }
                  onChange={ handleChange }
                />
                <Form.TextInput
                  label='Nomor Izin Usaha'
                  name='nomor_izin_usaha'
                  value={ values.nomor_izin_usaha }
                  onChange={ handleChange }
                />
              </Form.Column>
            </Form.Row>
            <Form.Row>
              <Form.Column lg={ 12 } md={ 12 }>
                <button
                  className='btn btn-primary float-right'
                  onClick={ handleSubmit }>
                  Simpan
                </button>
              </Form.Column>
            </Form.Row>
          </Form>
        </div>
      </div>
    )
  );
};

export default withFormik({
  mapPropsToValues: (props) => ({
    dep_village_id: '',
    dep_name: '',
    dep_address: '',
    ref_jenis_id: props.typeId,
    golongan: '',
    penanggung_jawab: '',
    jumlah_karyawan: '',
    jumlah_penjamah_makanan: '',
    nomor_izin_usaha: '',
    nik: '',
    name: '',
    last_name: '',
    address: '',
    sex: '',
    birth_place: '',
    birth_date: Date.now(),
    village_id: '',
    job_id: '',
    religion_id: '',
    marital_status_id: 1,
    contact: '',
  }),
  handleSubmit: async (values, { setStatus }) => {
    const newValues = { ...values };
    const arrName = newValues.name.split(' ');
    newValues.last_name =
      arrName[ arrName.length - 1 ] !== newValues.name
        ? arrName[ arrName.length - 1 ]
        : ' ';
    newValues.birth_date = moment(newValues.birth_date).format('YYYY-MM-DD');
    try {
      const result = await Service.post('/department/create', newValues);
      setStatus({ ...result, formData: newValues });
    } catch (error) {
      console.log(error);
    }
  },
})(
  withReference(
    [ fetchSexs(), getDistrics(), getReligions(), getJobs() ],
    [ 'sexs', 'districts', 'religions', 'jobs' ]
  )(Form1)
);
